import * as yup from 'yup';
import docs from './attachments';
import {
  consentimentoDadosSensiveis,
  cpfResponsavelLegal,
  nomeDoTutor,
  parentesco,
  acessoContraCheque,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const HerdeiroLegalANSchema = () => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  return yup.object({
    ...parentesco,
    ...cpfResponsavelLegal,
    ...nomeDoTutor,
    ...dadosSensiveis,
    ...acessoContraCheque,
    ...consentimentoAcertoFinanceiro,
    ...aceiteInss,
    ...declaracaoVeracidade,
    ...docs.HerdeiroLegalANDocs.rules,
  });
};

export const HerdeiroLegalANInitialValues = {
  parentesco: '',
  cpfResponsavelLegal: '',
  nomeDoTutor: '',
  consentimentoDadosSensiveis: '',
  acessoContraCheque: '',
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  declaracaoVeracidade: false,
  ...docs.HerdeiroLegalANDocs.initialValues,
};

export const HerdeiroLegalANDocs = {
  ...docs.HerdeiroLegalANDocs.docs,
};
